import { render, staticRenderFns } from "./ImportTables.vue?vue&type=template&id=2ef8553d&scoped=true&"
import script from "./ImportTables.vue?vue&type=script&lang=js&"
export * from "./ImportTables.vue?vue&type=script&lang=js&"
import style0 from "./ImportTables.vue?vue&type=style&index=0&id=2ef8553d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8553d",
  null
  
)

export default component.exports